
import React, { useEffect, useRef } from 'react';
import './kindwords.css';

const KindWordsJSX = () => {
    const textRef = useRef(null);

    useEffect(() => {
        const element = textRef.current;

        if (!element) return;

        const words = [
            'Beautiful',
            'Amazing',
            'Funny',
            'Talented',
            'Appreciated'
        ];

        const period = 2000;

        let wordIndex = 0;
        let text = '';
        let isDeleting = false;
        let timeoutId;

        const tick = () => {
            const currentWord = words[wordIndex % words.length];

            if (isDeleting) {
                text = currentWord.substring(0, text.length - 1);
            } else {
                text = currentWord.substring(0, text.length + 1);
            }

            element.innerHTML = `<span class="wrap">${text}</span>`;

            let delay = 300 - Math.random() * 100;

            if (isDeleting) {
                delay /= 2;
            }

            if (!isDeleting && text === currentWord) {
                delay = period;
                isDeleting = true;
            } else if (isDeleting && text === '') {
                isDeleting = false;
                wordIndex++;
                delay = 500;
            }

            timeoutId = setTimeout(tick, delay);
        };

        tick();

        // Cleanup when the component is unmounted
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <div className="kind-container">
            <div className="my-auto">
                <div id="swap-words2">
                    <h2>
                        Remember you are&nbsp;
                        <span
                            ref={textRef}
                            className="txt-rotate"
                        ></span>
                    </h2>

                    <div className="text-center">
                        <h5
                            id="conscious"
                            className="h5 mt-4 grey-text"
                        >
                            Conscious Motivation
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KindWordsJSX;

